import React, { Component, Fragment } from 'react'
import VehicleDetails from '.';
import VehicleDetailsPrincipalInformation from 'components/VehicleDetails/VehicleDetailsPrincipalInformation';

import './VehicleDetails.scss';

class VehicleDetailsCharacteristicInformation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			arrowMoreItems: false,
			listMoreItems: false,
			firstOpen: true
		}
		this.renderitemsRowsItemsInformation = this.renderitemsRowsItemsInformation.bind(this)
	}

	renderitemsRowsItemsInformation() {
		let _item = this.props.characteritics.listFormatted.map((option, index) => {
			return (
					<Fragment  key={index}>
					<li className={"VehicleDetails__list__item"}>
						<h2 class="VehicleDetails__list__item__title">{option.pos1 && option.pos1.name ? option.pos1.name : undefined}</h2>
						<strong id={'VehicleCharacteristicPos1'} class="VehicleDetails__list__item__value">{option.pos1 && option.pos1.desc ? option.pos1.desc : undefined}</strong>
					</li>
					<li className={"VehicleDetails__list__item"}>
						<h2 class="VehicleDetails__list__item__title">{option.pos2 && option.pos2.name ? option.pos2.name : undefined}</h2>
						<strong id={'VehicleCharacteristicPos2'} class="VehicleDetails__list__item__value">{option.pos2 && option.pos2.desc ? option.pos2.desc : undefined}</strong>
					</li>
					</Fragment>)
		})
		return _item
	}
	renderPrincipalInformation() {
		return (
			<ul class="VehicleDetails__list">
					{this.props.principalInformations.typeCar ?
						<Fragment>
                {this.props.principalInformations.location &&
                  <li class="VehicleDetails__list__item VehicleDetails__list__item__fullWidth">
                    <h2 class="VehicleDetails__list__item__title">Cidade</h2>
                    <strong id={'VehiclePrincipalInformationLocation'} class="VehicleDetails__list__item__value">{this.props.principalInformations.location}</strong>
                  </li>
                }
								<li class="VehicleDetails__list__item">
									<h2 class="VehicleDetails__list__item__title">Ano</h2>
									<strong id={'VehiclePrincipalInformationYear'} class="VehicleDetails__list__item__value">{this.props.principalInformations.year}</strong>
								</li>
								<li class="VehicleDetails__list__item">
									<h2 class="VehicleDetails__list__item__title">KM</h2>
									<strong id={'VehiclePrincipalInformatiOnodometer'} class="VehicleDetails__list__item__value">{this.props.principalInformations.odometer}</strong>
								</li>
								<li class="VehicleDetails__list__item">
									<h2 class="VehicleDetails__list__item__title">Câmbio</h2>
									<strong id={'VehiclePrincipalInformationTransmission'} class="VehicleDetails__list__item__value">{this.props.principalInformations.transmission}</strong>
								</li>
								<li class="VehicleDetails__list__item">
									<h2 class="VehicleDetails__list__item__title">Carroceria</h2>
									<strong id={'VehiclePrincipalInformationBodyType'} class="VehicleDetails__list__item__value">{this.props.principalInformations.bodyType}</strong>
								</li>
								<li class="VehicleDetails__list__item">
									<h2 class="VehicleDetails__list__item__title">Combustível</h2>
									<strong id={'VehiclePrincipalInformationFuel'} class="VehicleDetails__list__item__value">{this.props.principalInformations.fuel}</strong>
								</li>
								{
									this.props.principalInformations.finalPlate == undefined ?
									undefined
									:
									<li class="VehicleDetails__list__item">
										<h2 class="VehicleDetails__list__item__title">Final de placa</h2>
										<strong id={'VehiclePrincipalInformationFinalPlate'} class="VehicleDetails__list__item__value">{this.props.principalInformations.finalPlate}</strong>
									</li>

								}
								<li class="VehicleDetails__list__item">
									<h2 class="VehicleDetails__list__item__title">Cor</h2>
									<strong id={'VehiclePrincipalInformationColor'} class="VehicleDetails__list__item__value">{this.props.principalInformations.color}</strong>
								</li>
								{
									this.props.characteritics.listFormatted && this.props.characteritics.listFormatted.length > 0 ?
									this.renderitemsRowsItemsInformation() : null
								}
						</Fragment>
						:
						<Fragment>
              {this.props.principalInformations.location &&
                <li class="VehicleDetails__list__item VehicleDetails__list__item__fullWidth">
                  <h2 class="VehicleDetails__list__item__title">Cidade</h2>
                  <strong id={'VehiclePrincipalInformationLocation'} class="VehicleDetails__list__item__value">{this.props.principalInformations.location}</strong>
                </li>
              }
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Ano</h2>
								<strong id={'VehiclePrincipalInformationYear'} class="VehicleDetails__list__item__value">{this.props.principalInformations.year}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Marchas</h2>
								<strong id={'VehiclePrincipalInformatiOnodometer'} class="VehicleDetails__list__item__value">{this.props.principalInformations.shift}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Quilometragem</h2>
								<strong id={'VehiclePrincipalInformationTransmission'} class="VehicleDetails__list__item__value">{this.props.principalInformations.odometer}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Tipo de motor</h2>
								<strong id={'VehiclePrincipalInformationBodyType'} class="VehicleDetails__list__item__value">{this.props.principalInformations.engine}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Cor</h2>
								<strong id={'VehiclePrincipalInformationFuel'} class="VehicleDetails__list__item__value">{this.props.principalInformations.color}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Refrigeração</h2>
								<strong id={'VehiclePrincipalInformationFinalPlate'} class="VehicleDetails__list__item__value">{this.props.principalInformations.cooling}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Estilo</h2>
								<strong id={'VehiclePrincipalInformationColor'} class="VehicleDetails__list__item__value">{this.props.principalInformations.bodyType}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Cilindrada</h2>
								<strong id={'VehiclePrincipalInformationDateCreated'} class="VehicleDetails__list__item__value">{this.props.principalInformations.cubicCentimeter}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Partida</h2>
								<strong id={'VehiclePrincipalInformationColor'} class="VehicleDetails__list__item__value">{this.props.principalInformations.starter}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Freio dianteiro /traseiro</h2>
								<strong id={'VehiclePrincipalInformationDateCreated'} class="VehicleDetails__list__item__value">{this.props.principalInformations.break}</strong>
							</li>
							<li class="VehicleDetails__list__item">
								<h2 class="VehicleDetails__list__item__title">Alimentação</h2>
								<strong id={'VehiclePrincipalInformationColor'} class="VehicleDetails__list__item__value">{this.props.principalInformations.charge}</strong>
							</li>
						</Fragment>
					}
			</ul>
		)
	}
	render() {
		return (
				<VehicleDetails className={this.props.className ? this.props.className : ''} id={this.props.id ? this.props.id : ''} title={this.props.title ? this.props.title : ''}>
					{this.renderPrincipalInformation()}
				</VehicleDetails>
		)
	}
}
export default VehicleDetailsCharacteristicInformation
